import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import { Checkbox } from '../../../components/ui/Checkbox';

const CustomReportBuilder = ({ isOpen, onClose, onSave }) => {
  if (!isOpen) return null;

  const accountOptions = [
    { value: 'revenue', label: 'Revenue' },
    { value: 'cogs', label: 'Cost of Goods Sold' },
    { value: 'expenses', label: 'Operating Expenses' },
    { value: 'assets', label: 'Assets' },
    { value: 'liabilities', label: 'Liabilities' },
    { value: 'equity', label: 'Equity' }
  ];

  const groupingOptions = [
    { value: 'account_type', label: 'Account Type' },
    { value: 'department', label: 'Department' },
    { value: 'project', label: 'Project' },
    { value: 'month', label: 'Month' },
    { value: 'quarter', label: 'Quarter' }
  ];

  const calculationOptions = [
    { value: 'sum', label: 'Sum' },
    { value: 'average', label: 'Average' },
    { value: 'count', label: 'Count' },
    { value: 'min', label: 'Minimum' },
    { value: 'max', label: 'Maximum' }
  ];

  return (
    <div className="fixed inset-0 bg-background/80 backdrop-blur-sm z-1030 flex items-center justify-center p-4">
      <div className="bg-card rounded-lg border border-border shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
        <div className="p-4 md:p-6 border-b border-border flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 bg-accent/10 rounded-md flex items-center justify-center">
              <Icon name="Wrench" size={20} color="var(--color-accent)" />
            </div>
            <h3 className="font-heading font-semibold text-lg md:text-xl text-foreground">
              Custom Report Builder
            </h3>
          </div>
          <Button
            variant="ghost"
            size="sm"
            onClick={onClose}
            iconName="X"
          />
        </div>

        <div className="flex-1 overflow-y-auto p-4 md:p-6">
          <div className="space-y-6">
            <div>
              <Input
                label="Report Name"
                type="text"
                placeholder="Enter report name"
                required
              />
            </div>

            <div>
              <Input
                label="Description"
                type="text"
                placeholder="Brief description of the report"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
              <Select
                label="Primary Grouping"
                options={groupingOptions}
                value="account_type"
                onChange={() => {}}
                required
              />

              <Select
                label="Secondary Grouping"
                options={groupingOptions}
                value=""
                onChange={() => {}}
              />
            </div>

            <div>
              <label className="block font-body font-medium text-sm text-foreground mb-3">
                Select Accounts
              </label>
              <div className="space-y-2 p-4 bg-muted/30 rounded-lg border border-border">
                {accountOptions?.map((account) => (
                  <Checkbox
                    key={account?.value}
                    label={account?.label}
                  />
                ))}
              </div>
            </div>

            <div>
              <Select
                label="Calculation Method"
                description="How to calculate values"
                options={calculationOptions}
                value="sum"
                onChange={() => {}}
                required
              />
            </div>

            <div>
              <label className="block font-body font-medium text-sm text-foreground mb-3">
                Display Options
              </label>
              <div className="space-y-2 p-4 bg-muted/30 rounded-lg border border-border">
                <Checkbox label="Show comparison with previous period" />
                <Checkbox label="Include percentage changes" />
                <Checkbox label="Display subtotals" />
                <Checkbox label="Show transaction count" />
                <Checkbox label="Include notes section" />
              </div>
            </div>
          </div>
        </div>

        <div className="p-4 md:p-6 border-t border-border flex flex-col sm:flex-row justify-end gap-3">
          <Button
            variant="outline"
            onClick={onClose}
            className="flex-1 sm:flex-initial"
          >
            Cancel
          </Button>
          <Button
            variant="default"
            onClick={onSave}
            iconName="Save"
            iconPosition="left"
            className="flex-1 sm:flex-initial"
          >
            Save Template
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CustomReportBuilder;